/* eslint-disable prefer-const */
/*
 * 解析 query格式字符串为 object
 */
export function parseQuery(query) {
    var queryWithoutStart = query.indexOf('?') === 0 ? query.substring(1) : query;
    var uaFormated = {};
    var strs = queryWithoutStart.split('&');
    for (var _i = 0, strs_1 = strs; _i < strs_1.length; _i++) {
        var querySingle = strs_1[_i];
        uaFormated[querySingle.split('=')[0]] = unescape(querySingle.split('=')[1]);
    }
    return uaFormated;
}
/**
 * @description base64转blob
 * @param urlData base64编码
 */
export function convertBase64UrlToBlob(urlData) {
    var arr = urlData.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
//# sourceMappingURL=common.js.map